module.exports = __webpack_public_path__ + "static/img/commissionOne.10f5414.svg";


//////////////////
// WEBPACK FOOTER
// ./static/fxView/images/commissionOne.svg
// module id = xIWc
// module chunks = 4